<section class="c-section--static">
	<div class="c-text--center">
        <div [class]="vm.headerClass">
            <div class="o-container">
                <div class="o-grid">
                    <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="vm.product === 'SIFFI'">
                        <a id="headerLogoSiffi" href="javascript:void(0);"
                           (click)="vm.navigateToRoot($event)"
                           style="cursor: pointer; z-index: 10000; width: 124px; height: 33px; margin-left: 39px;margin-top:30px;"
                           class="c-header__logo c-logo c-logo--siffi-green c-logo--siffi-green@up-to-md"></a>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="vm.product === 'MINUDOC'">
                        <a id="headerLogoMinudoc" href="javascript:void(0);"
                           (click)="vm.navigateToRoot($event)"
                           style="cursor: pointer; z-index: 10000; width: 186px; height: 80px;"
                           class="c-header__logo c-logo c-logo--{{this.vm.logoSuffix}}"></a>
                    </div>
                    <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="vm.product === 'PREVISIT'">
                        <a id="headerLogoPrevisit" href="javascript:void(0);"
                           (click)="vm.navigateToRoot($event)"
                           style="cursor: pointer; z-index: 10000; width: 187px; height: 80px;background-size: auto 40%;"
                           class="c-header__logo c-logo c-logo--previsit c-logo--previsit@up-to-md"></a>
                    </div>
                </div>
            </div>
            
			<!-- Language menu -->
			<nav class="c-nav c-nav--tab-bar top-bar" style="z-index: 9999; right: 30px; margin-top: 30px;">
				<div class="o-container">
					<div class="c-nav__menu">
						<ul class="c-nav__list">
							<li class="c-nav__item" *ngIf="vm.product === 'SIFFI'">
								<siffi-language-picker [currentLocale]="vm.locale" (localeSelected)="vm.setLocale($event)"></siffi-language-picker>
							</li>
							<li class="c-nav__item c-nav__dd" [ngClass]="{ 'c-nav__dd--open': vm.isLanguageMenuOpen }" *ngIf="vm.product !== 'SIFFI'">
								<a id="selectedLangMenu" class="c-nav__link c-nav__dd-toggle c-nav__dd-toggle--arrow" (click)="vm.isLanguageMenuOpen = !vm.isLanguageMenuOpen">
									<i class="c-flag c-flag--{{ vm.getLocaleOption(vm.locale).icon }} c-nav__thumb" aria-hidden="true"></i>
									<span id="selectedLangValue" class="c-nav__label c-text c-text--uppercase">{{ vm.getLocaleOption(vm.locale).shortLabel }}</span>
								</a>
								<div class="c-nav__dd-menu">	
									<ul class="c-nav__dd-list">
										<ng-container *ngFor="let language of vm.locales ; let $index=index">
											<li class="c-nav__dd-item" *ngIf="language.locale !== vm.locale" (click)="vm.setLocale(language.locale)">
												<a id="selectLang{{$index}}" href="javascript:void(0)" class="c-nav__dd-link" >
													<i class="c-flag c-flag--{{ language.icon }} c-nav__dd-icon c-nav__thumb" aria-hidden="true"></i>
													<span id="selectLangValue{{$index}}" class="c-text c-text--uppercase">{{ language.shortLabel }}</span>
												</a>
											</li>
										</ng-container>
									</ul>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</nav>
		</div>
		<div style="margin-top: 25px;">
			<h1 class="c-header__title c-section__title--sm c-text--lg c-text--center"
	            *ngIf="!vm.showCompletedMessage && vm.isAvailable && !vm.showComplianceSurvey">
	            {{ "Surveys.Survey_Title" | translateUnauthenticated }}
	        </h1>
	        &nbsp;
		</div>
	</div>

	<div class="compliance-survey" *ngIf="vm.showComplianceSurvey">
		<div class="compliance-survey__questions">
			<div class="compliance-survey__wrap">
				<div class="compliance-survey__progress">
					<div class="compliance-survey__progress-meta">
						<span>Section {{ (vm.currentComplianceSectionIndex || 0) + 1 }} / {{ vm.getComplianceQuestionSections(vm.complianceQuestionnaire).length }}</span>
						<span>{{ vm.getCurrentComplianceQuestionGroup()?.questions.length }} questions</span>
					</div>
					<div class="compliance-survey__progress-bar"><i [style.width]="vm.getComplianceSectionProgress()"></i></div>
				</div>

				<ng-container *ngIf="vm.getCurrentComplianceQuestionGroup() as group">
					<div class="compliance-survey__block-head">
						<div class="compliance-survey__section-subtitle">{{ group.titleKey | translateUnauthenticated }}</div>
					</div>

					<div class="compliance-survey__q-card"
						 [ngClass]="{ 'question-error': vm.complianceInvalidQuestionIds && vm.complianceInvalidQuestionIds[question.id] }"
						 *ngFor="let question of group.questions; let questionIndex = index">
						<h4 class="compliance-survey__q-legend">
							<span class="compliance-survey__q-num">{{ questionIndex + 1 }}.</span>{{ vm.getDisplayTextForTranslatable(question) }}
						</h4>

						<div class="compliance-survey__answer" *ngIf="question.answerType === 'TEXT' || question.answerType === 'NUMBER'">
							<input class="compliance-survey__text-input"
								   [type]="question.answerType === 'TEXT' ? 'text' : 'number'"
								   [placeholder]="question.answers[0]?.defaultText || 'Enter your response'"
								   [value]="vm.getComplianceAnswerValue(question, question.answers[0])"
								   (input)="vm.setComplianceAnswerValue(question, question.answers[0], $event.target.value)" />
						</div>

						<div [ngClass]="vm.isComplianceMultiSelect(question) ? 'compliance-survey__checklist' : 'compliance-survey__likert'"
							 *ngIf="question.answerType !== 'TEXT' && question.answerType !== 'NUMBER'">
							<div [ngClass]="vm.isComplianceMultiSelect(question) ? 'compliance-survey__check' : 'compliance-survey__opt'"
								 *ngFor="let answer of question.answers">
								<input *ngIf="vm.isComplianceMultiSelect(question)"
									   type="checkbox"
									   [id]="'answer-' + answer.id"
									   [checked]="vm.isComplianceSelected(question, answer)"
									   (change)="vm.toggleComplianceAnswer(question, answer, $event.target.checked)" />
								<label *ngIf="vm.isComplianceMultiSelect(question)" [for]="'answer-' + answer.id">{{ vm.getDisplayTextForTranslatable(answer) }}</label>

								<input *ngIf="!vm.isComplianceMultiSelect(question)"
									   type="radio"
									   [id]="'answer-' + answer.id"
									   [name]="'question-' + question.id"
									   [checked]="vm.isComplianceSelected(question, answer)"
									   (change)="vm.setComplianceAnswer(question, answer)" />
								<label *ngIf="!vm.isComplianceMultiSelect(question)" [for]="'answer-' + answer.id">{{ vm.getDisplayTextForTranslatable(answer) }}</label>

								<input *ngIf="vm.getDisplayTextForTranslatable(answer).trim().endsWith(':')"
									   class="compliance-survey__inline-input"
									   type="text"
									   [value]="vm.getComplianceAnswerValue(question, answer)"
									   (input)="vm.setComplianceAnswerValue(question, answer, $event.target.value)" />
							</div>
						</div>
					</div>
				</ng-container>

				<p class="compliance-survey__error" *ngIf="vm.complianceValidationError">Please answer every question before submitting.</p>
				<p class="compliance-survey__error" *ngIf="vm.complianceSubmitError">Could not submit the survey. Please try again.</p>
				<div class="compliance-survey__nav">
					<button type="button" class="compliance-survey__button compliance-survey__button--ghost" (click)="vm.previousComplianceSection()" [disabled]="vm.isFirstComplianceSection()">Previous</button>
					<button type="button" class="compliance-survey__button" *ngIf="!vm.isLastComplianceSection()" (click)="vm.nextComplianceSection()">Next</button>
					<button type="button" class="compliance-survey__button" *ngIf="vm.isLastComplianceSection()" (click)="vm.submitComplianceSurvey()" [disabled]="vm.complianceSubmitting">
						{{ vm.complianceSubmitting ? 'Submitting...' : 'Submit answers' }}
					</button>
				</div>
			</div>
		</div>
	</div>

	<section class="compliance-completion" *ngIf="vm.showCompletedMessage && vm.showComplianceAssessmentCompletedMessage" aria-labelledby="compliance-completion-title" aria-live="polite">
		<div class="compliance-completion__hero">
			<svg class="compliance-completion__check" viewBox="0 0 48 48" fill="none" aria-hidden="true"><circle cx="24" cy="24" r="22" fill="#dcecdd"/><path d="m14 24 7 7 13-14" stroke="#287638" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>
			<h1 id="compliance-completion-title">{{ 'Surveys.Compliance_Assessment_Completed_Title' | translateUnauthenticated }}</h1>
			<p>{{ 'Surveys.Compliance_Assessment_Completed_Message' | translateUnauthenticated }}</p>
		</div>
		<section class="compliance-completion__next" aria-labelledby="compliance-next-title">
			<h2 id="compliance-next-title">{{ 'Surveys.Compliance_Assessment_Next_Title' | translateUnauthenticated }}</h2>
			<p>{{ 'Surveys.Compliance_Assessment_Next_Message' | translateUnauthenticated }}</p>
		</section>
		<section class="compliance-completion__support" aria-labelledby="compliance-support-title">
			<svg class="compliance-completion__heart" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>
			<div>
				<h2 id="compliance-support-title">{{ 'Surveys.Compliance_Assessment_Support_Title' | translateUnauthenticated }}</h2>
				<p>{{ 'Surveys.Compliance_Assessment_Support_Message' | translateUnauthenticated }}</p>
				<a class="compliance-completion__book" [href]="vm.counsellingLoginUrl">
					<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14m-6-6 6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>
					{{ 'Surveys.Compliance_Assessment_Book_Counselling' | translateUnauthenticated }}
				</a>
			</div>
		</section>
	</section>

	<div style="margin: 20px 5px;" *ngIf="!vm.showComplianceSurvey && !(vm.showCompletedMessage && vm.showComplianceAssessmentCompletedMessage)">
        <div class="c-card" style="min-height:150px;">
            <div class="c-content u-osb-xxl@up-to-md" *ngIf="!vm.loading">
                <div style="margin-top: 15px" *ngIf="!vm.showCompletedMessage">
                    <div *ngIf="vm.showSurveyCompletedError">
                        <p class="c-text c-text--center u-osb-lg">
                            {{ 'Surveys.Survey_Already_Completed' | translateUnauthenticated }}</p>
                    </div>
                    <div *ngIf="vm.showDataExpiredError">
                        <p class="c-text c-text--center u-osb-lg">{{ 'Surveys.Survey_Data_Expired' | translateUnauthenticated
                            }}</p>
                    </div>
                    <div *ngIf="vm.showLinkIsNotCorrectError">
                        <p class="c-text c-text--center u-osb-lg">{{ 'Surveys.Survey_Link_Not_Correct' | translateUnauthenticated
                            }}</p>
                    </div>
                    <div *ngIf="vm.isAvailable">
                        <div class="c-content c-content--xxl">
                            <p class="c-text c-text--center u-osb-lg">{{ vm.getSurveyStartLabel() }}</p>
                            <div class="o-grid o-grid--center-h u-osb-lg">
                                <div class="o-grid__cell o-grid__cell--center-h o-grid__cell--w-20@md-and-up">
                                    <button id="startSurveyButton" type="button"
                                            class="c-button c-button--s1 c-button--fit" (click)="vm.openSurvey()">
                                        {{ 'Surveys.Survey_Start' | translateUnauthenticated }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="c-content c-content" *ngIf="vm.showCompletedMessage">
                    <div *ngIf="!vm.showComplianceAssessmentCompletedMessage">
                        <p class="c-text c-text--center c-text--lg">{{ 'Surveys.Results_Title' | translateUnauthenticated }}</p>
                        <p class="c-text c-text--center" *ngIf="vm.showSubmittingMessage" style="margin-top: 24px;">{{ 'Surveys.Submit_Message' | translateUnauthenticated }}</p>
                        <div class="o-grid o-grid--center-v" style="margin-top: 24px" *ngIf="!vm.showSubmittingMessage">
                            <div class="o-grid__cell o-grid__cell--left">
                                <div id="evaluationContainer"></div>
                            </div>
                            <div class="o-grid__cell o-grid__cell--right u-hidden@up-to-md" id="container">
                                <div class="s-slider-container"></div>
                            </div>
                        </div>
                        <div class="o-grid o-grid--center-v">
                            <div class="o-grid__cell o-grid__cell--left">
                                <p class="c-text c-text--center" style="margin-top: 40px">
                                    {{ ('Surveys.App_Download' | translateUnauthenticated).replace('%s', vm.appName) }}</p>
                                <div class="o-grid o-grid--center-v o-grid--center-h" style="margin-top: 20px;">
                                    <div style="padding-left:0px !important;"
                                         class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
                                        <a href="{{vm.iosLink}}" target="_blank" rel="noreferrer noopener"
                                           class="c-header__btn"> <img
                                                src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/header/app-store-en.png"
                                                alt="App Store">
                                        </a>
                                    </div>
                                    <div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
                                        <a href="{{vm.androidLink}}" target="_blank" rel="noreferrer noopener"
                                           class="c-header__btn"> <img
                                                src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/header/google-play-en.png"
                                                alt="Google Play">
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
			<loader-overlay *ngIf="vm.loading"></loader-overlay>
        </div>
	</div>
</section>
